import { RemoveIcon } from './RemoveIcon.jsx';
import styles from './RemoveItemButton.module.css';

export function RemoveItemButton({ onClick }) {
  return (
    <button className={styles.button} type="button" onClick={onClick}>
      <RemoveIcon />
      Fjern
    </button>
  );
}
